import { createNamedApi } from '@essent/common';

import { ReviewStatisticsService } from './services/review-statistics.service';
import { ReviewsService } from './services/reviews.service';

export const getReviewsApi = createNamedApi(
  '[Reviews] Get reviews',
  ReviewsService
);

export const getReviewStatisticsApi = createNamedApi(
  '[ReviewStatistics] Get Review Statistics',
  ReviewStatisticsService
);
